import {makeStyles} from "@mui/styles"

const useStyles = makeStyles({
    btm_small:{
        padding:0,
        margin:0,
        fontFamily:"Lato",
        fontWeight:500
    },
    popover_root:{
        width:"100%",
        height:"100%",
        display:"flex",
        justifyContent:"center",
        alignItems:"center"
    },
    list:{
        padding:0,
        margin:0
    },
    listText:{
        color:"#FFFF",
        fontFamily:"Lato",
        fontWeight:"bold",
        fontSize:"14px"
    }
})

export default useStyles